import PendoIconButton from '../icon-button/pendo-icon-button.vue.js';
import PendoDivider from '../divider/pendo-divider.vue.js';
import PendoCollapseTransition from '../../utils/pendo-collapse-transition.vue.js';
import { PendoAnalytics } from '../../directives/analytics/pendo-analytics.js';

var script = {
  name: 'PendoCard',
  components: {
    PendoIconButton,
    PendoDivider,
    PendoCollapseTransition
  },
  directives: {
    PendoAnalytics
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    height: {
      type: [String, Number],
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    headerMinHeight: {
      type: String,
      default: '48px'
    },
    bodyMinHeight: {
      type: String,
      default: '240px'
    },
    footerMinHeight: {
      type: String,
      default: '155px'
    },
    shadow: {
      type: String,
      default: 'never',
      validator: shadow => ['always', 'hover', 'never'].includes(shadow)
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsed: false,
      collapseTooltipContent: 'Collapse'
    };
  },
  computed: {
    showHeader() {
      return !!this.$slots.header || !!this.$slots.headerRight || !!this.$slots.headerActions || !!this.$slots.title || !!this.title || this.collapsible;
    }
  },
  methods: {
    collapseCard() {
      requestAnimationFrame(() => {
        this.collapsed = true;
        this.collapseTooltipContent = 'Expand';
        this.$emit('collapse-change', {
          collapsed: this.collapsed
        });
      });
    },
    expandCard() {
      requestAnimationFrame(() => {
        this.collapsed = false;
        this.collapseTooltipContent = 'Collapse';
        this.$emit('collapse-change', {
          collapsed: this.collapsed
        });
      });
    },
    toggleCardCollapse() {
      this.collapseTooltipContent = null;
      if (this.collapsed) {
        return this.expandCard();
      }
      this.collapseCard();
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-card.vue2.js.map
